package com.ervasstudio.tracoemovimento.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class NewsLetterData(
    @SerialName("email")
    val email: String
)